import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GraphDataResponse, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { formatDateHuman } from '../../../ui-components/standard-date.pipe';

@Component({
  selector: 'sa-pump-volume-stats',
  styleUrls: ['./pump-volume-stats.component.scss'],
  templateUrl: './pump-volume-stats.component.html',
})
export class PumpVolumeStatsComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public loading = false;
  public timeframes = [7, 14, 30];
  public timeframe = this.timeframes[0];
  public percentiles = [0, 0.25, 0.5, 0.75];
  public percentile = this.percentiles[0];
  public datasets: GraphDataResponse = this.initializePumpVolumeStats();
  public isNoDataSubject$$ = new BehaviorSubject<boolean>(true);

  public chartColors: any[] = [
    {
      backgroundColor: ['rgb(32,118,135, 0.5)'],
      borderColor: ['rgb(32,118,135)'],
    },
  ];

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      const resolvedRegionID = regionID || 0;

      this.regionID = resolvedRegionID;
      this.fracsID = resolvedRegionID === 0 ? [] : this.fracsID;
      this.fetchPumpVolumeStats();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.fracsID = fracsID;
        this.fetchPumpVolumeStats();
      }
    });
  }

  private fetchPumpVolumeStats(): void {
    this.loading = true;
    this.isNoDataSubject$$ = new BehaviorSubject<boolean>(false);
    const pumpVolumeTimeframe = this.kpiDashboardService.getLocalStorage('pump_volume_timeframe');
    if (pumpVolumeTimeframe) {
      this.timeframe = pumpVolumeTimeframe;
    }

    const pumpVolumePercentile = this.kpiDashboardService.getLocalStorage('pump_volume_percentile');
    if (pumpVolumePercentile) {
      this.percentile = pumpVolumePercentile;
    }
    this.kpiDashboardService
      .getPumpVolumePercentileStats$(this.regionID, this.fracsID, this.timeframe, this.percentile)
      .subscribe((data) => {
        if (!data) {
          this.datasets = this.initializePumpVolumeStats();
          this.loading = false;
          return;
        }

        this.datasets = data;

        this.datasets.labels.map((label, index) => {
          this.datasets.labels[index] = formatDateHuman(label);
        });

        data.datasets.forEach((value) => {
          const sum = value.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          if (value.data.length !== 0 && sum !== 0) {
            this.isNoDataSubject$$?.next(false);
          } else {
            this.isNoDataSubject$$?.next(true);
          }
        });

        this.loading = false;
      });
  }

  private initializePumpVolumeStats(): GraphDataResponse {
    this.isNoDataSubject$$?.next(true);
    return {
      datasets: [
        {
          data: [0],
          label: '',
        },
      ],
      labels: [''],
    };
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('pump_volume_timeframe', this.timeframe);
    this.fetchPumpVolumeStats();
  }

  public onMedianChange(percentile: number) {
    this.percentile = percentile;
    this.kpiDashboardService.setLocalStorage('pump_volume_percentile', this.percentile);
    this.fetchPumpVolumeStats();
  }
}
